// File Metadata:
// Filename: ApprovalActions.js
// Version: 1.00
// Created: 2025-03-23 01:03:22
// Last Modified: 2025-04-01 17:27:27
// Authors: [Your Name]
// Description: A brief summary of what this file does

import { useState } from 'react'
import {
    Box, Button, TextField,
    Dialog, DialogTitle,
    DialogContent, DialogActions,
    Stack, Typography
} from '@mui/material'
import { useUpdateQualityStatusMutation } from '../../api/receptionsApiSlice'
import useAuth from '../../../hooks/useAuth'

const ApprovalActions = ({ receptionId, currentStatus }) => {
    const { isQuality, isManager, isAdmin } = useAuth()
    const [updateStatus] = useUpdateQualityStatusMutation()
    const [notes, setNotes] = useState('')
    const [dialogOpen, setDialogOpen] = useState(false)
    const [pendingStatus, setPendingStatus] = useState(null)

    const handleStatusUpdate = async (status) => {
        setPendingStatus(status)
        setDialogOpen(true)
    }

    const handleConfirm = async () => {
        try {
            await updateStatus({
                id: receptionId,
                status: pendingStatus,
                notes
            })
            setDialogOpen(false)
            setNotes('')
        } catch (err) {
            console.error('Failed to update status:', err)
        }
    }

    const canApprove = isQuality || isManager || isAdmin
    
    return (
        <Box sx={{ p: 2 }}>
            {!canApprove ? (
                <Typography color="error">
                    Only Quality, Manager or Admin can approve receptions
                </Typography>
            ) : (
                <Stack direction="row" spacing={2}>
                    <Button
                        variant="contained"
                        color="success"
                        onClick={() => handleStatusUpdate('APPROVED')}
                        disabled={currentStatus === 'APPROVED'}
                    >
                        Approve
                    </Button>
                    <Button
                        variant="contained"
                        color="error"
                        onClick={() => handleStatusUpdate('REJECTED')}
                        disabled={currentStatus === 'REJECTED'}
                    >
                        Reject
                    </Button>
                    <Button
                        variant="contained"
                        color="warning"
                        onClick={() => handleStatusUpdate('NEEDS_REVIEW')}
                        disabled={currentStatus === 'NEEDS_REVIEW'}
                    >
                        Request Review
                    </Button>
                </Stack>
            )}
            <Dialog open={dialogOpen} onClose={() => setDialogOpen(false)}>
                <DialogTitle>Confirm Status Update</DialogTitle>
                <DialogContent>
                    <TextField
                        fullWidth
                        multiline
                        rows={4}
                        value={notes}
                        onChange={(e) => setNotes(e.target.value)}
                        placeholder="Add notes about this decision..."
                        sx={{ mt: 2 }}
                    />
                </DialogContent>
                <DialogActions>
                    <Button onClick={() => setDialogOpen(false)}>Cancel</Button>
                    <Button onClick={handleConfirm} variant="contained">
                        Confirm
                    </Button>
                </DialogActions>
            </Dialog>
        </Box>
    )
}

export default ApprovalActions
